import { ensureNumber } from "@intelligems/ig-utils";

export const fullDateTimeConverter = function (
  date: number | string | null | undefined,
  timeZone?: string,
  locale?: string,
  hideTimeZone?: boolean
) {
  if (!date) return null;
  if (timeZone) {
    return new Intl.DateTimeFormat(locale || "en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZoneName: hideTimeZone ? undefined : "short",
      timeZone,
    }).format(ensureNumber(date));
  } else {
    return new Intl.DateTimeFormat(locale || "en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZoneName: hideTimeZone ? undefined : "short",
    }).format(ensureNumber(date));
  }
};

export const dateTimeConverter = (
  date: number | null | undefined,
  locale?: string,
  timeZone?: string,
  showOngoing?: boolean
) => {
  if (!date) return showOngoing ? "Ongoing" : null;

  if (timeZone) {
    return new Intl.DateTimeFormat(locale || "en-US", {
      year: "2-digit",
      month: "numeric",
      day: "numeric",
      timeZone: timeZone,
    }).format(date);
  } else {
    return new Intl.DateTimeFormat(locale || "en-US", {
      year: "2-digit",
      month: "numeric",
      day: "numeric",
    }).format(date);
  }
};

export const shortDateTimeConverter = (
  date: number | null | undefined,
  locale?: string,
  timeZone?: string,
  showOngoing?: boolean
) => {
  if (!date) return showOngoing ? "Ongoing" : null;

  if (timeZone) {
    return new Intl.DateTimeFormat(locale || "en-US", {
      month: "short",
      day: "numeric",
      timeZone: timeZone,
    }).format(date);
  } else {
    return new Intl.DateTimeFormat(locale || "en-US", {
      month: "short",
      day: "numeric",
    }).format(date);
  }
};

const getDaysBetweenDates = (startTime: number, endTime: number) => {
  const start = new Date(Math.floor(startTime));
  const end = new Date(Math.floor(endTime));
  const diffInTime = end.getTime() - start.getTime();
  return diffInTime / (1000 * 3600 * 24);
};

export { getDaysBetweenDates };
